








export default
	data: ->
		label: ''

